import { defineMessages } from "react-intl";

export const pluginStatusMessages = defineMessages({
  active: {
    id: "rQOS7K",
    defaultMessage: "Active",
    description: "status label active",
  },
  deactivated: {
    id: "ho75Lr",
    defaultMessage: "Deactivated",
    description: "status label deactivated",
  },
});
